import { AdvancementStatusType, advancementStatuses } from '../constants';

type AdvancementInfo = Partial<{
  dateCompleted: string | null;
  dateEarned: string | null;
  dateCompletedEarned: string | null;
  awardedDate: string | null;
  dateAwarded: string | null;
  awardedUserId: number | string | null;
  markedCompletedDate: string | null;
  markedCompletedUserId: number | null;
  leaderApprovedUserId: number | null;
  leaderApprovedDate: string | null;
  counselorApprovedUserId: number | null;
  awarded: boolean | null;
  status: string | null;
  dateStarted: string | null;
  percentCompleted: number | null;
}>;

const { STARTED, COMPLETED, COUNSELOR_APPROVED, APPROVED, AWARDED } =
  advancementStatuses;

const getStarted = ({ dateStarted }: AdvancementInfo) => dateStarted;

/**
 *
 * @param {object} param
 * @param {string | null} [param.dateCompleted]
 * @param {string | null} [param.dateEarned]
 * @param {string | null} [param.dateCompletedEarned]
 * @param {string | null} [param.markedCompletedDate]
 * @returns
 */
const getCompleted = ({
  dateCompleted,
  dateEarned,
  dateCompletedEarned,
  markedCompletedDate,
}: AdvancementInfo) =>
  dateCompleted || dateEarned || dateCompletedEarned || markedCompletedDate;

const getApproved = ({ leaderApprovedDate }: AdvancementInfo) =>
  leaderApprovedDate;

const getAwarded = ({ awardedDate, dateAwarded }: AdvancementInfo) =>
  awardedDate || dateAwarded;

const getByStatus = (
  advancement: AdvancementInfo,
  status: AdvancementStatusType,
) => {
  switch (status) {
    case STARTED: {
      return getStarted(advancement);
    }
    case COMPLETED:
    case COUNSELOR_APPROVED: {
      return getCompleted(advancement);
    }
    case APPROVED: {
      return getApproved(advancement);
    }
    case AWARDED: {
      return getAwarded(advancement);
    }
    default: {
      return '';
    }
  }
};

export default {
  getByStatus,
  getStarted,
  getCompleted,
  getApproved,
  getAwarded,
};
